// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Graph_overlay__RSKQR","board":"Graph_board__2pCaq"};